import { Injectable } from '@angular/core';
import { IPermission } from '../models';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private localStorageService;

  constructor() {
    this.localStorageService = localStorage;
   }

  setCurrentSession(currentUser): void {
    this.localStorageService.setItem('currentUser', JSON.stringify(currentUser));
  }

  GetCurrentSession(): string {
    return this.localStorageService.getItem('currentUser');
  }

  getToken(){
    return JSON.parse(this.localStorageService.getItem('currentUser'));
  }
  
  GetToken(): void {
    return JSON.parse(this.localStorageService.getItem('currentUser')).access_token;
  }

  SetPermissions(_permissions: IPermission[]): void {
    this.localStorageService.setItem('Perms', JSON.stringify(_permissions));
  }

  GetPermissions(): IPermission[] {
    const PERMISSIONS = JSON.parse(this.localStorageService.getItem('Perms')) as IPermission[];
    if (PERMISSIONS !== null) return PERMISSIONS;
    return [];
  }
}
